<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="5">
        <v-card color="orange ligthten-3">
          <v-card-text>
            <div>{{ infoSolicitud }}</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="1">
        <app-impresion-formulario
          :creditoId="model.id"
          :empresaId="model.empresaId"
          :productoDescripcion="model.producto"
        ></app-impresion-formulario>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="4">
        <v-file-input
          v-model="archivosASubirLegajo"
          placeholder="Seleccione el archivo"
          label="Archivo Solicitud Firmada"
          chips
          counter
          show-size
          prepend-icon="search"
        >
        </v-file-input>
      </v-col>

      <v-col cols="2">
        <v-btn color="blue" @click="uploadFilesLegajo">Subir Archivos</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { http } from '@/axios';
import legajoVirtualService from '@/services/legajoVirtual.service';
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      archivosASubirLegajo: [],
      errorAlAgregarDocumentacion: null,
      model: {},
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['user', 'error']),
    infoSolicitud() {
      return (
        'Crédito Número ' +
        this.model.numero +
        ' del Cliente ' +
        this.model.personaNombre +
        ', DNI: ' +
        this.model.personaDocumento
      );
    },
  },
  props: {
    creditoId: {
      type: String,
    },
    personaId: {
      type: String,
    },
    empresaId: {
      type: String,
    },
  },
  created() {
    this.loadInfoConsulta();
  },
  methods: {
    ...mapMutations([
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    async loadInfoConsulta() {
      this.loading = true;
      try {
        var result = await http.get(
          'creditos/getinforesumida?id=' + this.creditoId
        );

        if (result != null) {
          console.log(result);

          this.model = result;
          console.log(this.model.personaNombre);
        } else {
          this.alertError(
            'Atención, ID de consulta inválido:' + this.creditoId
          );
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async uploadFilesLegajo() {
      if (this.archivosASubirLegajo.length === 0) {
        this.alertWarning(
          'No se ha seleccionado ningún archivo para subir al legajo.'
        );
        return;
      }
      if (!this.creditoId) {
        this.alertWarning(
          'No se puede adjuntar la documentación. Intente refrescar el enlace.'
        );
        return;
      }

      const response = await legajoVirtualService.uploadLegajoVirtual(
        null,
        this.personaId,
        this.creditoId,
        this.empresaId,
        this.archivosASubirLegajo,
        true,
        '',
        'legajoCredito'
      );

      if (response.success) {
        this.alertSuccess(response.message);
        this.archivosASubirLegajo = [];
      } else {
        this.alertError(response.message);
        this.errorAlAgregarLegajo = true;
        return false;
      }

      // const formData = new FormData();

      // formData.append('personaId',this.personaId);
      // formData.append('creditoId',this.creditoId);
      // formData.append('empresaId',this.empresaId);
      // formData.append('completaDocumentacion', true);
      // formData.append('tipoDocumentacion','legajoCredito');

      // for(let i = 0;i<this.archivosASubirLegajo.length;i++){
      //     formData.append('files',this.archivosASubirLegajo[i]);
      // }

      // try{
      //     await http.post('/personas/uploadfileslegajovirtual', formData );

      //     this.alertSuccess('El legajo se completó con éxito.');

      //     this.archivosASubirLegajo=[];
      // } catch(error) {
      //     // Error
      //     this.alertError(error)
      //     this.errorAlAgregarLegajo = true;
      //     return false;
      // }
      return true;
    },
  },
};
</script>
